export function init($name = '') {
    const parent = $($name);

    if (!parent.length) {
        return;
    }

    parent.find('input').click(function() {
        const parentThat = $(this).parents($name);

        if ($(this).prop('checked')) {
            parentThat.next().removeClass('h-form').attr('required', 'required');
            return;
        }

        parentThat.next().addClass('h-form').removeAttr('required');
    });
}